import { BifrostBackendApi, BifrostBackendNestApi } from "../gateways/BifrostBackendApi";
import appConfig from "../appconfig";
import { store } from "../store";

const getApi = () => {
	const useNestOrderPaymentFlow =
		store.getters.featureToggles &&
		store.getters.featureToggles.useNewDiscountsModel;
	return useNestOrderPaymentFlow ? BifrostBackendNestApi : BifrostBackendApi;
};

const prepareCartProductsForVoucherRedemption = () => {
	const cartProducts = store.getters.cartProducts || [];
	const singleProducts = [];
	const productsInGroups = [];

	for (const cartProduct of cartProducts) {
		singleProducts.push(cartProduct.productId);
		if(cartProduct.groups.length) {
			for( const group of cartProduct.groups) {
				productsInGroups.concat(group.selectedProducts);
			}
		}
	}

	return {
		singleProducts: Array.from(new Set(singleProducts)),
		productsInGroups: Array.from(new Set(productsInGroups))
	};
};

const VouchersProvider = {
	async findAll() {
		const res = await getApi().get("/vouchers", {
			params: {
				tenantId: appConfig.tenantId
			},
			headers: {
				Authorization: store.getters.jwtToken
			}
		});

		return res.data.sort(function(a,b){
			return new Date(b.updatedAt) - new Date(a.updatedAt);
		});
	},

	async insert({
		voucherCode,
		voucherName,
		expiryDate,
		isActive,
		maxNumberOfUsages = null,
		usesPerTransaction = 1,
		onlinePosProductId = null
	}) {
		return getApi().post(`/vouchers`, {
			tenantId: appConfig.tenantId,
			voucherName,
			voucherCode,
			expiryDate,
			isActive,
			maxNumberOfUsages,
			usesPerTransaction,
			onlinePosProductId
		}, {
			headers: {
				Authorization: store.getters.jwtToken
			}
		});
	},

	async delete(id) {
		return getApi().delete(`/vouchers/${id}`, {
			headers: {
				Authorization: store.getters.jwtToken
			},
			params: {
				tenantId: appConfig.tenantId
			}
		});
	},

	async get(id) {
		return getApi().get(`/vouchers/${id}`, {
			headers: {
				Authorization: store.getters.jwtToken
			},
			params: {
				tenantId: appConfig.tenantId
			}
		});
	},

	async update(id, data) {
		return getApi().put(`/vouchers/${id}?tenantId=${data.tenantId}`, data, {
			headers: {
				Authorization: store.getters.jwtToken
			}
		});
	},

	async redeemVoucher(voucherCodeOrId, shopId = null, skipReservation = false, label = "") {
		const isBM100 = appConfig.isBM100();
		const res = isBM100
			? await getApi()
				.post(store.getters.featureToggles.useNewDiscountsModel ? "/vouchers/_verify" : "/vouchers-verify", {
					voucherCodeOrId,
					shopId,
					channel: appConfig.channelAlias(),
					deliveryMethod: store.getters.tenantSpecificData && store.getters.tenantSpecificData.deliveryChoice,
					skipReservation,
					label,
					cartProducts: prepareCartProductsForVoucherRedemption()
				}, {
					headers: {
						Authorizationidp: store.getters.applicationUserIdpToken
					}
				})
			: await getApi()
				.get(store.getters.featureToggles.useNewDiscountsModel ? "/vouchers/_verify" : "/vouchers-verify", {
					params: {
						tenantId: appConfig.tenantId,
						voucherCodeOrId,
						shopId,
						channel: appConfig.channelAlias(),
						deliveryMethod: store.getters.tenantSpecificData && store.getters.tenantSpecificData.deliveryChoice,
						skipReservation,
						label
					},
					headers: {
						Authorizationidp: store.getters.applicationUserIdpToken
					}
				});
		return res.data;
	},
	async getUserVouchers({membershipType, milestoneIntervalAchieved} = {}) {
		const res = await BifrostBackendNestApi
			.get("/vouchers/userVouchers", {
				headers: {
					Authorizationidp: store.getters.applicationUserIdpToken
				},
				params: {
					milestoneIntervalAchieved,
					membershipType
				}
			});
		return res.data;
	}
};

export default Object.freeze(VouchersProvider);
